import { MergeOption } from 'src/app/domainObjects/transformers/joinerTransform';

export class JoinerMergedOptionViewModel {
    state: boolean
    field: string
    nodeColor:string


    constructor(mergeOption: MergeOption) {
      this.state = mergeOption.state;
      this.field = mergeOption.field;
      this.nodeColor = mergeOption.nodeColor;
     
    }
  
    toJoinerMergeOption(): MergeOption {
      const mergeOption = new MergeOption();
      mergeOption.state = this.state;
      mergeOption.field = this.field;
      //mergeOption.nodeColor = this.nodeColor;
   
      
      return mergeOption;
    }
  }

  
